import { TextField, Autocomplete } from '@mui/material';
import LockedTextField from './LockedTextField';

export default function LockedOrUnlockedTextField({
    label,
    value,
    multilineRows,
    locked,
    useAutocomplete,
    autocompleteOptions,
    onOptionSelect,
    setFieldValue,
    unlockedProps
}) {
    if (locked) {
        return <LockedTextField label={label} value={value} multilineRows={multilineRows} />;
    }

    const textFieldProps = {
        label,
        multiline: multilineRows > 1,
        minRows: multilineRows > 1 && multilineRows,
        fullWidth: true,
        ...unlockedProps
    };

    // Keep multiline height when no value
    const multiLineStyles = {
        '& .MuiInputBase-input': {
            minHeight: `${multilineRows}em`
        }
    };

    return useAutocomplete && !unlockedProps?.disabled ? (
        <Autocomplete
            options={autocompleteOptions}
            getOptionLabel={(option) => option.name}
            freeSolo
            onChange={(e, selected) => {
                setFieldValue(unlockedProps?.id, selected?.name || '');
                onOptionSelect?.(selected);
            }}
            inputValue={value || ''}
            onInputChange={(e, newInput) => setFieldValue?.(unlockedProps?.id, newInput)}
            renderInput={(params) => (
                <TextField
                    {...params}
                    {...textFieldProps}
                    sx={multilineRows > 1 && !value ? multiLineStyles : {}}
                    inputProps={{
                        ...params.inputProps,
                        onKeyDown: (e) => {
                            if (e.key === 'Enter' && value) {
                                e.stopPropagation();
                            }
                        }
                    }}
                />
            )}
        />
    ) : (
        <TextField {...textFieldProps} value={value} />
    );
}
